<template>
  <div class="main-content">
    <avue-crud ref="crud" :data="tableData" :option="option" :table-loading="showLoading" :page.sync="page"
      @on-load="onLoad">
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">网关名称 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.name" placeholder="请输入网关名称" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">网关地址 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.macAddr" placeholder="请输入网关地址" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属用户/ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.userId" placeholder="请输入" clearable maxlength="50"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">手机号码 :
              </span>
              <div class="width300">
                <el-input v-model="searchData.phone" placeholder="请输入" clearable maxlength="11"></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">所属分组/ID :
              </span>
              <div class="width300">
                <el-input v-model="searchData.groupId" placeholder="请输入分组名称/ID" clearable maxlength="50"></el-input>
              </div>
            </div>
            <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
              class="marginLeft10">搜索</el-button>
            <el-button size="medium" type="info" @click="handleReset" class="marginLeft10"
              style="margin-bottom: 10px">重置</el-button>
          </div>
        </div>
      </template>
      <template slot="name" slot-scope="{ row }">
        <div class="gateway-name-cell">
          <el-image
            v-if="row.image"
            class="gateway-name-thumb"
            :src="row.image"
            :preview-src-list="[row.image]"
            fit="cover"
          />
          <span class="gateway-name-text">{{ row.name }}</span>
        </div>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleDownload(row,1)">下载报文</el-button>
        <el-button type="text" size="mini" @click="handleDownload(row,2)">获取负载波形数据</el-button>
      </template>
    </avue-crud>
    <el-dialog v-if="timeDialogShow" :title="`${'选择下载周期'}`" :visible.sync="timeDialogShow" width="40%"
      :before-close="handleClose" :close-on-click-modal="false">
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="timeType">
          <el-radio-group v-model="form.timeType" size="mini">
            <el-radio-button label="0" border>近三天</el-radio-button>
            <el-radio-button label="1" border style="margin-left: 15px">近两周</el-radio-button>
            <el-radio-button label="2" border style="margin-left: 15px">近一个月</el-radio-button>
            <el-radio-button label="3" border style="margin-left: 15px">近三个月</el-radio-button>
            <el-radio-button label="4" border style="margin-left: 15px">近六个月</el-radio-button>
            <el-radio-button label="5" border style="margin-left: 15px">近一年</el-radio-button>
          </el-radio-group>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" :loading="showLoadingTime" @click="submit(form)">确定</el-button>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import { gatewayList, gatewayExport } from "@/api/collect/gateway";
import dayjs from "dayjs";
import qs from "qs";
import { exportExcel } from "@/components/exportExcel";

export default {
  name: "index",
  data() {
    return {
      searchData: {
        title: "",
        createTime: "",
        userId: this.$route.query.id || "",
        macAddr: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "网关名称",
            prop: "name",
            align: "left",
            headerAlign: "center",
          },
          {
            label: "网关地址",
            prop: "macAddr",
          },
          {
            label: "型号",
            prop: "foreignCommType",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
        ],
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "",
            prop: "timeType",
            type: "text",
            maxlength: 50,
            span: 24,
          },
        ],
      },
      timeDialogShow: false,
      dialogApiType: 1,//提交按钮调用的接口类型 1-下载报文，2-下载负载识别波形
      showLoadingTime: false,
      form: {
        exportID: "", //导出id
        timeType: 0, //导出时间选择
      },
    };
  },
  created() { },
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.bindTimeStart = dayjs(this.searchData.createTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        searchData.bindTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      gatewayList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
        macAddr: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //下载
    handleDownload(e,type) {
      this.form.timeType = 0;
      this.form.exportID = e.id;
      this.dialogApiType = type;
      this.timeDialogShow = true;
    },
    handleClose() {
      this.timeDialogShow = false;
      console.log(111111);
    },
    async submit() {
      this.showLoadingTime = true;
      let params = {
        week: this.form.timeType,
        id: this.form.exportID,
      };
      let url = "/web/collect/gateway/export";
      if(this.dialogApiType == 2){
        url = "/web/collect/lflrd/gateway/wave/export";
      }
      await exportExcel(
        url,
        params,
        this.$store.state.user.Token
      );
      this.showLoadingTime = false;
      this.timeDialogShow = false;
    },
  },
};
</script>

<style scoped>
.gateway-name-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  text-align: left;
}

.gateway-name-thumb {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 4px;
  vertical-align: middle;
}

.gateway-name-text {
  word-break: break-all;
}

::v-deep .gateway-name-thumb .el-image__inner {
  cursor: pointer;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px !important;
  box-shadow: none !important;
}

::v-deep .el-radio-button__inner {
  border: 1px solid #dcdfe6 !important;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 4px !important;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  box-shadow: 0 0 0 0 #409eff;
}
</style>
